module.exports = __webpack_public_path__ + "static/Mockup@2x-ae52f802a1a745cee1c78d69291f435d.png";